import { CapoPlugin } from "/home/runner/work/WebSite/WebSite/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];